export default {
  computed: {
    subAccount () {
      return this.$store.state.header?.headerData?.isSubaccount ?? false
    }
  }
}
